export default __webpack_public_path__ + "static/media/banners-amistad-coche-330x330.487fa475.webp";